export enum CartStatus {
  Active = 1,
  Inactive,
  Submitted,
  Deleted,
  Abandoned
}
